import Animatable from '../../../atoms/container/animatable';
import ArrowRightIcon from '../../../atoms/icons/arrowRight';
import Colors from '@shared/assets/style/default/color';
import Direction from '../../../../../shared/types/enums/direction';
import Focus from '../../../../../shared/types/enums/focus';
import LanguageItem from '../../../elements/language/languageItem';
import LanguageListArrowContainer from '../../../atoms/container/languageListArrowContainer';
import LanguageListContainer from '../../../atoms/container/languageListContainer';
import List from '../list';
import TranslationManager from '../../../../../shared/assets/locale/translationsManager';
import initCategories from '@shared/actions/categories/initCategories';
import keepWatchingRequest from '@shared/api/initial/keepWatchingRequest';
import useTransform from '../../../../../shared/components/utils/hooks/useTransform';
import { LanguageListProps as Props } from '../../../../../shared/types/props/language';
import { magicRemoteSelector } from '../../../../../shared/store/slices/magicRemote.slice';
import {
  focusSelector,
  pushFocus,
} from '../../../../../shared/store/slices/focus.slice';
import { useEffect, useRef } from 'react';
import {
  useAppDispatch,
  useAppSelector,
} from '../../../../../shared/store/hooks';

const LANGUAGE_DISPLACEMENT = 62;

function LanguagesList({ languages }: Props) {
  const dispatch = useAppDispatch();
  const { focus } = useAppSelector(focusSelector);
  const { enabled } = useAppSelector(magicRemoteSelector);

  const focusRef = useRef(focus);
  const originalLanguage = useRef(TranslationManager.currentLanguage);
  focusRef.current = focus;

  const initialIndex = languages.findIndex((item) => {
    return TranslationManager.currentLanguage === item;
  });

  const [style, setStyle] = useTransform(
    initialIndex,
    LANGUAGE_DISPLACEMENT,
    Direction.VERTICAL
  );

  // Event handlers

  const onChange = (index: number, increment: number | undefined) => {
    if (increment) {
      setStyle(increment);
      TranslationManager.setLanguage(languages[index]);
    }
  };

  // Effect hooks

  useEffect(() => {
    focusRef.current !== Focus.LANGUAGES &&
      dispatch(pushFocus(Focus.LANGUAGES));
    return () => {
      // When app language, categories must be fetched once again with the new language
      if (originalLanguage.current !== TranslationManager.currentLanguage) {
        initCategories();
        keepWatchingRequest();
      }
    };
  }, []);

  return (
    <LanguageListContainer id={'languageListContainer'}>
      <Animatable
        style={style}
        animation={{ transition: 'transform 0.15s' }}
        id={'languageItem'}
      >
        <List
          direction={Direction.VERTICAL}
          focus={Focus.LANGUAGES}
          initialIndex={initialIndex}
          onChange={onChange}
        >
          {languages.map((item, index) => {
            return <LanguageItem index={index} key={index} item={item} />;
          })}
        </List>
      </Animatable>
      {!enabled && (
        <LanguageListArrowContainer id={'arrowContainer'}>
          <ArrowRightIcon color={Colors.selector} width={18} />
        </LanguageListArrowContainer>
      )}
    </LanguageListContainer>
  );
}

export default LanguagesList;
